import {RemoteGetDenialLetterOdonto} from 'data/usecases/private/authorizations-odonto';
import {GetDenialLetterOdonto} from 'domain/usecases/private/authorizations-odonto/get-denial-letter-odonto';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {authorizationsOdontoFlowEndpoints} from '../../endpoints';

export const makeGetDenialLetterOdonto = (): GetDenialLetterOdonto =>
	new RemoteGetDenialLetterOdonto(
		makeBFFApiUrl(authorizationsOdontoFlowEndpoints.authorizationsOdontoDenialLetter),
		makeAuthorizeHttpClientDecorator(),
	);
